import { a as languages } from "../../core-8vQkh0Rd.js";
import { n as extend } from "../../language-D-vtM55V.js";
import { a as clikeString } from "../../patterns-C0vJBvXO.js";
import "./json.js";
//#region src/prism/languages/json5.js
languages.json5 = extend("json", {
	"property": [RegExp(clikeString.source + "(?=\\s*:)"), {
		pattern: /(?!\d)(?:(?!\s)[$\w\xa0-\uffff])+(?=\s*:)/,
		alias: "unquoted"
	}],
	"string": clikeString,
	"number": /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
});
//#endregion

//# sourceMappingURL=json5.js.map